import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Image } from "react-bootstrap";
import Switch from "react-switch";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { makeStyles } from "@material-ui/core";
import AddOfferOfflineVendor from "../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOfflineVendor";
import AddOfferOnlineVendor from "../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOnlineVendor";
import isEmpty from "../../../../store/validation/is-Empty";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const OfferPopup = () => {
  const classes = useStyles();
  //state
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };
  const [state, setState] = useState({
    country: "",
    restaurant: "",
    state: "",
    City: "",
    open: false,
  });
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };
  const onOpenModal = () => {
    setState({
      open: true,
    });
  };
  const onCloseModal = () => {
    setState({
      open: false,
    });
  };

  const subscriptonStatus = useSelector((state) => {
    return !isEmpty(state.onboarding?.onboard_subscription_details)
      ? state.onboarding?.onboard_subscription_details
      : "";
  });

  const casualDiningOffers = useSelector((state) => {
    return !isEmpty(
      state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.offer_management
    )
      ? state.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.offer_management
      : "";
  });

  const fastFoodDiningOffers = useSelector((state) => {
    return !isEmpty(
      state.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.offer_management
    )
      ? state.onboarding?.onboard_subscription_details?.fast_food_dining_status
          ?.offer_management
      : "";
  });

  useEffect(() => {
    setSelectedTab(
      (subscriptonStatus?.casual_dining === true &&
        casualDiningOffers?.value === true &&
        casualDiningOffers?.offline_offer === true) ||
        (subscriptonStatus?.fast_food_dining === true &&
          fastFoodDiningOffers?.value === true &&
          fastFoodDiningOffers?.offline_offer === true)
        ? 1
        : 2
    );
  }, []);

  return (
    <React.Fragment>
      <button
        type="button"
        className="btn btn-danger text-normal btn-xs rounded"
        onClick={onOpenModal}
      >
        + Add Offer
      </button>
      <Modal
        open={state.open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "offer-event-main closeRemove min-height-100vh w-100",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="d-flex align-items-center py-3 px-4 border-bottom">
          <span className="pr-3 cursor" onClick={onCloseModal}>
            <Image
              alt="Back"
              width="20px"
              src={require("../../../../assets/images/UserManagement/backIcon.svg")}
            />
          </span>
          <div className="f12-400 c_black">Add New Offer</div>
        </div>
        <div className="d-flex align-items-start p-3">
          {(subscriptonStatus?.casual_dining === true &&
            casualDiningOffers?.value === true &&
            casualDiningOffers?.offline_offer === true) ||
          (subscriptonStatus?.fast_food_dining === true &&
            fastFoodDiningOffers?.value === true &&
            fastFoodDiningOffers?.offline_offer === true) ? (
            <Button
              variant="link"
              className={`enAddOffersOPtion ${
                selectedTab === 1 ? "active" : ""
              }`}
              onClick={(e) => handleTab(1)}
            >
              <Image
                src={
                  selectedTab === 1
                    ? require("../../../../assets/images/Menu/vandorGridMenu/1-red.svg")
                    : require("../../../../assets/images/Menu/vandorGridMenu/1.svg")
                }
                alt="Offline Offers"
                title="Offline Offers"
                width="40px"
                height="40px"
                className="ml-3"
              />
              <span className="active f12-400 pt-2 d-block w-100 mb-2">
                Offline Offers
              </span>
              <span className="w-100 f9-400 d-block">
                (Note: these offers can be only be used in your business
                location offline)
              </span>
            </Button>
          ) : null}
          {(subscriptonStatus?.casual_dining === true &&
            casualDiningOffers?.value === true &&
            casualDiningOffers?.online_offer?.value === true) ||
          (subscriptonStatus?.fast_food_dining === true &&
            fastFoodDiningOffers?.value === true &&
            fastFoodDiningOffers?.online_offer?.value === true) ? (
            <Button
              variant="link"
              className={`enAddOffersOPtion ml-3 ${
                selectedTab === 2 ? "active" : ""
              }`}
              onClick={(e) => handleTab(2)}
            >
              <Image
                src={
                  selectedTab === 2
                    ? require("../../../../assets/images/Menu/vandorGridMenu/1-red.svg")
                    : require("../../../../assets/images/Menu/vandorGridMenu/1.svg")
                }
                alt="Online Offers"
                title="Online Offers"
                width="40px"
                height="40px"
                className="ml-3"
              />
              <span className="active f12-400 pt-2 d-block w-100">
                Online Offers
              </span>
            </Button>
          ) : null}
        </div>
        {(casualDiningOffers?.offline_offer === true &&
          fastFoodDiningOffers?.offline_offer === true) ||
        (casualDiningOffers?.online_offer?.value === true &&
          fastFoodDiningOffers?.online_offer?.value === true) ? (
          <div className="sectionHeader border-0 d-flex align-items-center">
            <div className="f16-400 mr-4">User Templates for Design</div>
            <div className="d-flex align-items-center">
              <div className="f12-400 mr-2">No</div>
              <Switch
                onChange={toggleFunction}
                checked={checked.checked}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              />
              <div className="f12-400 ml-2">Yes</div>
            </div>
          </div>
        ) : null}
        <div className="px-3">
          {(selectedTab === 1 &&
            subscriptonStatus?.casual_dining === true &&
            casualDiningOffers?.value === true &&
            casualDiningOffers?.offline_offer === true) ||
          (subscriptonStatus?.fast_food_dining === true &&
            fastFoodDiningOffers?.value === true &&
            fastFoodDiningOffers?.offline_offer === true) ? (
            <AddOfferOfflineVendor />
          ) : null}
          {(selectedTab === 2 &&
            subscriptonStatus?.casual_dining === true &&
            casualDiningOffers?.value === true &&
            casualDiningOffers?.online_offer?.value === true) ||
          (subscriptonStatus?.fast_food_dining === true &&
            fastFoodDiningOffers?.value === true &&
            fastFoodDiningOffers?.online_offer?.value === true) ? (
            <AddOfferOnlineVendor />
          ) : null}
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default OfferPopup;
